import WhiteSpaceManagerExtension from "snb-components/src/Extensions/WhiteSpaceManagerExtension";

export default [
    new WhiteSpaceManagerExtension()
]